import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagedTableComponent } from '@shared/modules/tables/components/paged-table/paged-table.component';
import { ShowFieldPipe } from '@shared/modules/tables/pipes/show-field.pipe';
import { SkipPrimitivesPipe } from '@shared/modules/tables/pipes/skip-primitives.pipe';
import { MaterialModule } from '@shared/material/material.module';
import { SortableTableComponent } from './components/sortable-table/sortable-table.component';

@NgModule({
  declarations: [
    PagedTableComponent,
    ShowFieldPipe,
    SkipPrimitivesPipe,
    SortableTableComponent
  ],
  imports: [
    CommonModule,
    MaterialModule
  ],
  exports: [
    PagedTableComponent,
    SortableTableComponent
  ]
})
export class TablesModule {
}
